import Constants from '../config/const';

export const setCrop = ({
  x, y, width, height
}) => ({
  type: Constants.crop.set,
  x,
  y,
  width,
  height
});

export const resetCrop = () => ({ type: Constants.crop.reset });
